import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Pipe({
    name: 'dateFormatPipe',
})
export class dateFormatPipe implements PipeTransform {
    transform(value: string, user_locale:any) {
        moment.locale(user_locale);
        value = moment(value).format('L');

        return value;
    }
}


